import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { loanStatusInfo } from '../../cmg-1003/models';

import { Cmg1003LoanStatusHistoryStore } from './loan-status-history.store';

@Injectable({ providedIn: 'root' })
export class Cmg1003LoanStatusHistoryQuery extends Query<loanStatusInfo> {
  protected store: Cmg1003LoanStatusHistoryStore;

  dirtyChecker = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(Cmg1003LoanStatusHistoryStore);

    super(store);

    this.store = store;
  }
}
